export function tryParseInt(val) {
    let parsedVal = parseInt(val, 10);
    if (isNaN(parsedVal)) {
        parsedVal = null;
    }
    return parsedVal;
}
